import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const hm = (iso) => new Date(iso).toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });

// Red bar on every page when the A V Stone laptop has been silent for 5+ minutes.
export const LaptopBanner = () => {
  const [s, setS] = useState(null);
  useEffect(() => {
    const load = () => api.get("/avstone/laptop").then((r) => setS(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);
  if (!s || s.online || !s.last_seen) return null;
  return (
    <div data-testid="av-laptop-offline-banner"
      className="fixed top-0 inset-x-0 z-[70] bg-[#FF3B30] text-white px-4 py-2 text-sm font-semibold flex items-center gap-3 shadow-lg">
      <span className="w-2 h-2 rounded-full bg-white animate-pulse" />
      <span data-testid="av-laptop-offline-text">
        A V Stone laptop OFFLINE since {hm(s.last_seen)} ({s.offline_minutes} min) — cameras, plates and slab counts are paused. Check it is on and plugged in.
      </span>
    </div>
  );
};
